import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';

import type { IValidity } from '../types';
import {
	formatActiveFrom,
	getValidUntilParts,
	IValidityConfig,
} from '../validity/validityLabels';

interface IValidityCollapsedSummaryProps {
	config: IValidityConfig;
	selectedStartDate: string | null;
	validity: IValidity;
}

export const ValidityCollapsedSummary: FC<IValidityCollapsedSummaryProps> = ({
	config,
	selectedStartDate,
	validity,
}) => {
	const { t } = useTranslation('ticketshop');

	if (config.mode === 'static' && config.staticKeys) {
		return (
			<Typography variant="l1" color="solutions.600">
				{t(config.staticKeys.note)}
			</Typography>
		);
	}

	if (!selectedStartDate) {
		return (
			<Typography variant="l1" color="error.main">
				{t('ticket_detail.validity_title')}
			</Typography>
		);
	}

	const { date, time } = getValidUntilParts(selectedStartDate, validity);
	const untilLabel = time
		? t('ticket_detail.validity_collapsed_until', { date, time })
		: t('ticket_detail.validity_collapsed_until_no_time', { date });

	return (
		<Stack gap={1}>
			<Typography variant="b2" color="primary.main">
				{t('ticket_detail.validity_active_from_label')}{' '}
				{formatActiveFrom(selectedStartDate)}
			</Typography>
			<Typography variant="l1" color="solutions.600">
				{untilLabel}
			</Typography>
		</Stack>
	);
};
